import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { selectLoading } from '../../store/slice'
import { BOX_DATA, OVERVIEW_KEYS } from './helper'
import classes from './index.module.scss'
import { InfoItem } from './InfoItem'
import { MapItem } from './MapItem'

export const CompanyOverview = () => {
  const isLoading = useSelector(selectLoading('overview'))

  return (
    <Element className="positionRelative">
      {isLoading && <Loading />}
      <Element className="dFlex" style={{ opacity: isLoading ? 0 : 1 }}>
        {BOX_DATA.map((item, index) => {
          const isMapBox = index === BOX_DATA.length - 1
          const startKeyIndex = BOX_DATA.reduce(
            (prevVal, currVal, currIndex) =>
              currIndex < index ? prevVal + currVal.dataKeyCount : prevVal,
            0,
          )
          const endKeyIndex = startKeyIndex + item.dataKeyCount
          return (
            <Element
              key={index}
              className={classes.box}
              style={{
                borderColor: '#D5D5D5',
                color: '#3A414B',
                padding: isMapBox ? 0 : '10px 12px',
              }}
            >
              {item.title && (
                <Element className={classes.title} style={{ color: '#191D25' }}>
                  <Translate value={item.title} />
                </Element>
              )}

              {Object.keys(OVERVIEW_KEYS)
                .slice(startKeyIndex, endKeyIndex)
                .map((dataKey) => {
                  if (OVERVIEW_KEYS[dataKey] === OVERVIEW_KEYS.MAP) {
                    return <MapItem key={dataKey} />
                  }

                  return <InfoItem key={dataKey} dataKey={dataKey} />
                })}
            </Element>
          )
        })}
      </Element>
    </Element>
  )
}
